export enum toggleColorEnum {
  BLUE = 'var(--clr-actionable)',
  BLACK = 'black',
}
